import {
  CUENTA_CONTABLE_GRUPO_ENUM,
  CuentaContableGrupoEnumType,
} from "api/Types/CuentaContableGrupoEnum"
import { TFunction } from "i18next"

export interface TipoAsientoLabelsProps {
  tipo?: CuentaContableGrupoEnumType
  descripcion: string
}
export const TIPO_ASIENTO_LABELS = (
  t: TFunction
): Array<TipoAsientoLabelsProps> => [
  {
    tipo: undefined,
    descripcion: `${t("filtros.cuadroCuentas.allLabel")}`,
  },
  {
    tipo: CUENTA_CONTABLE_GRUPO_ENUM.FINANCIACION_BASICA,
    descripcion: `${t("filtros.cuadroCuentas.basicFinanceLabel")}`,
  },
  {
    tipo: CUENTA_CONTABLE_GRUPO_ENUM.ACTIVO_NO_CORRIENTE,
    descripcion: `${t("filtros.cuadroCuentas.nonCurrentAssetsLabel")}`,
  },
  {
    tipo: CUENTA_CONTABLE_GRUPO_ENUM.EXISTENCIAS,
    descripcion: `${t("filtros.cuadroCuentas.inventorsLabel")}`,
  },
  {
    tipo: CUENTA_CONTABLE_GRUPO_ENUM.ACREEDORES_Y_DEUDORES,
    descripcion: `${t("filtros.cuadroCuentas.accountPaybleLabel")}`,
  },
  {
    tipo: CUENTA_CONTABLE_GRUPO_ENUM.CUENTAS_FINANCIERAS,
    descripcion: `${t("filtros.cuadroCuentas.financialAccountLabel")}`,
  },
  {
    tipo: CUENTA_CONTABLE_GRUPO_ENUM.COMPRAS_Y_GASTOS,
    descripcion: `${t("filtros.cuadroCuentas.purchasesExpensesLabel")}`,
  },
  {
    tipo: CUENTA_CONTABLE_GRUPO_ENUM.VENTAS_E_INGRESOS,
    descripcion: `${t("filtros.cuadroCuentas.salesAndIncomeLabel")}`,
  },
  {
    tipo: CUENTA_CONTABLE_GRUPO_ENUM.GASTOS_DEL_PATRIMONIO_NETO,
    descripcion: `${t("filtros.cuadroCuentas.equityExpensesLabel")}`,
  },
  {
    tipo: CUENTA_CONTABLE_GRUPO_ENUM.INGRESOS_DEL_PATRIMONIO_NETO,
    descripcion: `${t("filtros.cuadroCuentas.equityIncomeLabel")}`,
  },
]
